import { api } from './index';

export const recentDevelopmentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRecentDevelopments: build.query({
      query: ({lang}) => `/recent-developments?lang=${lang}`,
      providesTags: ['RecentDevelopments'],
    }),
  }),
});

export const {
  useGetRecentDevelopmentsQuery,
} = recentDevelopmentsApi;
